module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/venue_an-7e8e2b145ee6ae7533762915842bb9f9.jpg";